import { prepareQueryParams } from '@homeviews/utils'
import { api, API_V2_BASE_URL } from '@homeviews/store'
import type {
  FilterType,
  MetaResponse,
  FilterResponse,
  Development,
  DevelopmentProfileType,
} from '@homeviews/models'
import type { MetaTotal } from '@homeviews/analytics'

interface IDevelopmentsResponse {
  data: Development[]
  meta: MetaResponse
}
interface IDevelopmentResponse {
  ID: number
  content?: string
  facilities: string[]
  video_url: string
  facility_suggestion?: string
  status?: string
  updated_at?: string
  title?: string
  media: any
  type: DevelopmentProfileType
}

type TypeID = number | string

type V2DevelopmentsQueryParams = {
  // When true, get Developments only for authenticated user
  portalDevelopments: boolean
  // When set, get Developments only that feature in top 10 of an Area Guide
  areaRanking?: '<11'
  // When set, get Developments only with "Red" TransparencyScore
  transparencyAward?: 4
}

export const developmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDevelopments: builder.query<IDevelopmentsResponse, any>({
      query: (params) => {
        return {
          url: '/developments',
          params: params,
        }
      },
      providesTags: <any>['DevelopmentEdit'],
    }),
    getV2Developments: builder.query<MetaTotal, V2DevelopmentsQueryParams>({
      query: (params) => ({
        url: `${API_V2_BASE_URL}/developments${prepareQueryParams(params)}`,
      }),
    }),
    getDevelopmentsFilters: builder.query<FilterResponse[], FilterType>({
      query: (filter) => ({
        url: `/developments/options/${filter}`,
      }),
    }),
    getDevelopment: builder.query<IDevelopmentResponse, TypeID>({
      query: (id) => {
        return {
          url: `/development-edits/${id}`,
        }
      },
    }),
    updateDevelopment: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/development-edits/${id}`,
          method: 'PATCH',
          body: data,
        }
      },
    }),
  }),
})

export const {
  useGetDevelopmentsQuery,
  useGetV2DevelopmentsQuery,
  useGetDevelopmentsFiltersQuery,
  useGetDevelopmentQuery,
  useUpdateDevelopmentMutation,
} = developmentsApi
